import type { RouteRecordRaw } from 'vue-router'

const wechatRiskRoutes: RouteRecordRaw[] = [
  {
    path: 'wechat-risk',
    component: () => import('@/pages/wechat-risk/layout.vue'),
    meta: { title: '微信风控', parent: '客户运营' },
    children: [
      {
        path: '',
        redirect: { name: 'WechatRiskContent' },
      },
      {
        path: 'content',
        name: 'WechatRiskContent',
        component: () => import('@/pages/wechat-risk/RiskContent.vue'),
        meta: { title: '风险内容' },
      },
      {
        path: 'events',
        name: 'WechatRiskEvents',
        component: () => import('@/pages/wechat-risk/RiskEvents.vue'),
        meta: { title: '风险事件' },
      },
    ],
  },
]

export default wechatRiskRoutes
